import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-flag',
    templateUrl: './flag.component.html',
    styleUrls: ['./flag.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlagComponent {
  @Input() country: any;

  public flags: Record<string, string> = {
    "BR": "assets/i/flags/flag-br.png",
    "CN": "assets/i/flags/flag-cn.png",
    "DE": "assets/i/flags/flag-de.png",
    "HK": "assets/i/flags/flag-hk.png",
    "IT": "assets/i/flags/flag-it.png",
    "JP": "assets/i/flags/flag-jp.png",
    "MX": "assets/i/flags/flag-mx.png",
    "US": "assets/i/flags/flag-us.png",
    "RU": "assets/i/flags/flag-ru.png",
    "HU": "assets/i/flags/flag-hu.png",
    "SG": "assets/i/flags/flag-sg.png",
    "AT": "assets/i/flags/flag-at.png",
    "UK": "assets/i/flags/flag-uk.png"
  };
}
